import { render, staticRenderFns } from "./StudentExam.vue?vue&type=template&id=508765a4"
import script from "./StudentExam.vue?vue&type=script&lang=js"
export * from "./StudentExam.vue?vue&type=script&lang=js"
import style0 from "./StudentExam.vue?vue&type=style&index=0&id=508765a4&prod&lang=css"
import style1 from "./StudentExam.vue?vue&type=style&index=1&id=508765a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports